import React from 'react';

/**
 * CohortSelector
 * 
 * Shows nothing if only one cohort (just the badge on the page header).
 * Shows a dropdown switcher if multiple cohorts available.
 * Always shows a cohort name badge inline.
 */
export default function CohortSelector({ cohorts, selectedCohort, onSelect, compact = false }) {
  if (!selectedCohort) return null;

  // Single cohort — just show a badge
  if (cohorts.length <= 1) {
    return (
      <div className="gm-cohort-badge">
        <span className="gm-cohort-badge-dot" />
        <span>{selectedCohort.name}</span>
        {selectedCohort.currentPeriod && (
          <span className="gm-cohort-badge-period">· {selectedCohort.currentPeriod}</span>
        )}
      </div>
    );
  }

  // Multiple cohorts — show a dropdown switcher
  return (
    <div className={`gm-cohort-selector ${compact ? 'gm-cohort-selector--compact' : ''}`}>
      <label className="gm-cohort-selector-label">Programme</label>
      <select
        className="gm-cohort-selector-select"
        value={selectedCohort.id}
        onChange={e => {
          const c = cohorts.find(c => c.id === e.target.value);
          if (c) onSelect(c);
        }}
      >
        {cohorts.map(c => (
          <option key={c.id} value={c.id}>
            {c.name}{c.currentPeriod ? ` · ${c.currentPeriod}` : ''}
          </option>
        ))}
      </select>
    </div>
  );
}
